import { useEffect, useState } from 'react';
import { ILicenceBasicInfo } from 'models/licence';
import { getLicenceBasicInfo } from 'requests/licence';

export const useWeaponLicenceModule = () => {
  const [licenceBasicInfo, setLicenceBasicInfo] = useState<ILicenceBasicInfo | null>(null);

  useEffect(() => {
    (async () => {
      const result = await getLicenceBasicInfo();
      if (result) {
        setLicenceBasicInfo(result);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hasWeaponLicenceModule = (): boolean | null => {
    if (!licenceBasicInfo) {
      return null;
    }

    return licenceBasicInfo.includeWeaponLicenceModule;
  };

  return { hasWeaponLicenceModule };
};
